const checkers = {
    namespaced: true,
    state: {
        numeral: {
            numeral: true,
            numeralThousandsGroupStyle: 'thousand',
            numeralDecimalScale: 2
        },
        numeralPositive: {
            numeral: true,
            numeralThousandsGroupStyle: 'thousand',
            numeralPositiveOnly: true,
            numeralDecimalScale: 2
        },
        numeralFx: {
            numeral: true,
            numeralThousandsGroupStyle: 'thousand',
            numeralPositiveOnly: true,
            numeralDecimalScale: 4
        },
        naturalNumber: {
            numeral: true,
            numeralThousandsGroupStyle: 'thousand',
            numeralPositiveOnly: true,
            numeralDecimalScale: 0
        },
        maxExpiryTime: new Date().setHours(23, 59, 0, 0)
    },
    getters: {
        numeral: function(state){
            return state.numeral;
        },
        numeralPositive: function(state){
            return state.numeralPositive;
        },
        numeralFx: function(state){
            return state.numeralFx;
        },
        naturalNumber: function(state){
            return state.naturalNumber;
        },
        maxExpiryTime: function(state){
            return state.maxExpiryTime;
        }
    }
}

export default checkers